import produce from 'immer';
import {
  EVENT_PARTNER_CREATE_REQUEST,
  EVENT_PARTNER_DETAILS_REQUEST,
  EVENT_PARTNER_LIST_REQUEST,
  EVENT_PARTNER_REWARD_LIST_REQUEST,
  EVENT_PARTNER_UPDATE_REQUEST,
} from '../../constants/event/eventPartnerConstants';

const initialState = {

};

const eventPartnerReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case EVENT_PARTNER_CREATE_REQUEST:
      break;
    case EVENT_PARTNER_UPDATE_REQUEST:
      break;
    case EVENT_PARTNER_LIST_REQUEST:
      break;
    case EVENT_PARTNER_DETAILS_REQUEST:
      break;
    case EVENT_PARTNER_REWARD_LIST_REQUEST:
      break;
    default:
      break;
  }
});

export default eventPartnerReducer;
